import { render, staticRenderFns } from "./transaction-skeleton.vue?vue&type=template&id=48cc6156&scoped=true"
import script from "./transaction-skeleton.vue?vue&type=script&lang=js"
export * from "./transaction-skeleton.vue?vue&type=script&lang=js"
import style0 from "./transaction-skeleton.vue?vue&type=style&index=0&id=48cc6156&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cc6156",
  null
  
)

export default component.exports